import React from 'react';

import Loadable from 'Shared/Loadable';
import useMatchMediaQuery from 'Shared/Hooks/useMediaQuery';

const LazyCookiesBar: React.FC = () => {
  const { matches: isDesktop } = useMatchMediaQuery('md');

  if (isDesktop) {
    return (
      <Loadable
        module={() =>
          import(/* webpackChunkName: "main-menu-cookiesbar" */ './CookiesBar')
        }
      />
    );
  }

  return null;
};

export default LazyCookiesBar;
